import { PeriodPickerProps } from '@touche-lts/panel-ui/dist/components/shared/period-picker'

export enum StatisticsTableSortProps {
    PRODUCT_NAME = 'productName',
    ACTIVE_SKUS = 'activeSkus',
    INVENTORY = 'inventory',
    SOLD = 'sold',
    REVENUE = 'revenueTotal',
    // ADDED_DATE = 'createdDate'
  }
  
  export interface StatisticsTableSearchProps {
    id: number
    productName: string
    storeName: string
    activeSkusMax: number
    activeSkusMin: number
    stockMax: number
    stockMin: number
    soldMin: number
    soldMax: number
    minRevenue: number
    maxRevenue: number
    addedOnPeriod: PeriodPickerProps['period']
  }